import { ArrowForwardIos, LocationOn } from '@mui/icons-material';
import { Grid, Paper, Typography } from '@mui/material';
import React from 'react';

export default function PlaceOfDelivery({ placeOfDelivery }) {
	return (
		<Paper
			elevation={3}
			sx={{
				backgroundColor: 'white.main',
				borderRadius: '8px',
				padding: '8px',
				display: 'flex',
				width: '100%',
				height: '100%',
			}}
		>
			<Grid
				container
				sx={{
					justifyContent: 'space-evenly',
					alignItems: 'center',
					textAlign: 'start',
				}}
			>
				<Grid
					item
					xs={2}
					xsm={2}
					sx={{ textAlign: { xs: 'start', xsm: 'center' } }}
				>
					<LocationOn />
				</Grid>
				<Grid item xs={8} xsm={8}>
					<Typography fontWeight='bold'>Lugar de entrega</Typography>
					<Typography>{placeOfDelivery}</Typography>
				</Grid>
				<Grid
					item
					xs={2}
					xsm={2}
					sx={{ textAlign: { xs: 'start', xsm: 'end' } }}
				>
					<ArrowForwardIos />
				</Grid>
			</Grid>
		</Paper>
	);
}
